import play from '../Assets/play.png'
import apple from '../Assets/apple.png'
import mobile from '../Assets/mobile.png'

const appPromo = {
  title: "Get exclusive app-only deals",
  subtitle: "Download the app now and unlock premium car offers.",
  description:
    "Buy, sell and explore verified cars directly from our mobile app. Faster deals. Better prices. Trusted experience.",
  storeButtons: [
    {
      id: 1,
      name: "App Store",
      image: apple,
      link: "#"
    },
    {
      id: 2,
      name: "Google Play",
      image: play,
      link: "#"
    }
  ],
  phoneImage: mobile
};

export default appPromo;